// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { propIn } from '../../../../../../../../common/utils/immutableHelper';
import friendlyTimeFormatter from '../../../../../../../../common/utils/datetime/friendlyTimeFormatter';
import { userIsInvited } from '../../../../../../../../common/users/userHelper';

// Selectors
import { getCurrentBoardEditorTimestamps } from '../boardEditorPanelSelector';

// Components
import Icon from '../../../../../../../components/icons/Icon';

// Styles
import './BoardEditorListEntryStatus.scss';
import { isBlocked } from '../../../../../../../../common/permissions/permissionUtil';

const mapStateToProps = createSelector(
    (_, { userId }) => userId,
    getCurrentBoardEditorTimestamps,
    (userId, editorTimestamps) => ({
        lastEditTimestamp: propIn([userId, 'lastEdit'], editorTimestamps) || 0,
        lastViewTimestamp: propIn([userId, 'lastView'], editorTimestamps) || 0,
        hasViewedParent: propIn([userId, 'hasViewedParent'], editorTimestamps) || false,
    }),
);

const BoardEditorListEntryStatusContent = ({
    user,
    boardEditorTimesFetched,
    lastEditTimestamp,
    lastViewTimestamp,
    isSpecificallyShared,
    hasViewedParent,
    permission,
    ...rest
}) => {
    if (!boardEditorTimesFetched) return null;

    if (isBlocked(permission)) return <span>Blocked</span>;

    if (userIsInvited(user))
        return (
            <span>
                <Icon name="feature-tick" /> Invite sent
            </span>
        );

    if (!lastEditTimestamp && !lastViewTimestamp) {
        return hasViewedParent || !isSpecificallyShared ? (
            <span>Never viewed</span>
        ) : (
            <span>
                <Icon name="feature-tick" /> Invite sent
            </span>
        );
    }

    if (lastEditTimestamp) {
        const editDisplayTime = friendlyTimeFormatter({
            timestamp: lastEditTimestamp,
            lessThanMinuteMessage: 'just now',
            showSuffix: true,
        });

        return <span>Edited {editDisplayTime}</span>;
    }

    const viewDisplayTime = friendlyTimeFormatter({
        timestamp: lastViewTimestamp,
        lessThanMinuteMessage: 'just now',
        showSuffix: true,
    });

    return <span>Viewed {viewDisplayTime}</span>;
};

const BoardEditorListEntryStatus = (props) => (
    <div className="BoardEditorListEntryStatus">
        <BoardEditorListEntryStatusContent {...props} />
    </div>
);

BoardEditorListEntryStatusContent.propTypes = {
    userId: PropTypes.string,
    user: PropTypes.object,
    boardEditorTimesFetched: PropTypes.bool,
    isSpecificallyShared: PropTypes.bool,
    hasViewedParent: PropTypes.bool,
    currentlyViewing: PropTypes.bool,
    lastEditTimestamp: PropTypes.number,
    lastViewTimestamp: PropTypes.number,
    permission: PropTypes.number,
};

export default connect(mapStateToProps)(BoardEditorListEntryStatus);
